import { render } from "./TakEoutsandwich.vue?vue&type=template&id=3506dcdb"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/TakEoutsandwich.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3506dcdb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3506dcdb', __exports__)) {
    api.reload('3506dcdb', __exports__)
  }
  
  module.hot.accept("./TakEoutsandwich.vue?vue&type=template&id=3506dcdb", () => {
    api.rerender('3506dcdb', render)
  })

}


export default __exports__